<template>
    <township-container toRoute="ci"> </township-container>
  </template>
  
  <script>
  import TownshipContainer from "@/components/township/TownshipContainerCi.vue";
  
  export default {
    components: {
      "township-container": TownshipContainer,
    },
  };
  </script>
  